import React, { useState } from "react";
import moment from "moment";
import MainPageDialog from "../../components/mainPageDialog";
import {
  useGetAppointmentSurveyQuery,
  useSaveAppointmentSurveyMutation,
} from "../../redux/service/appointments_service";
import { Loader } from "../../components/Loader";
import { getLoggedinUser, getLogedPid } from "../../userStore";
import { toast } from "react-toastify";
const AppointmentSurvey = ({
  appointment_id,
  setShowSurvey = () => {},
  showSurvey = false,
  withName = "",
  date = "",
  timeString = "",
  location = "",
}) => {
  const { data, isLoading } = useGetAppointmentSurveyQuery(
    {
      id: appointment_id,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const [saveAppointmentSurvey, { isLoading: isSaving }] =
    useSaveAppointmentSurveyMutation();

  const footerList = [
    {
      title: "Cancel",
      type: "cancel",
      action: () => onCancelHandler(),
    },
    {
      title: isLoading || isSaving ? "Saving..." : "Save",
      type: "save",
      disabled: data?.msg && !data?.sections,
      action: () => submitSurvey(),
    },
  ];
  const [surveyAnswers, setSurveyAnswers] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);

  const submitSurvey = async () => {
    if (!surveyAnswers || surveyAnswers?.length == 0) {
      setErrorMessage(true);
      return;
    }

    const user = getLoggedinUser();
    const payload = {
      appointment_id: appointment_id,
      pid: getLogedPid(),
      practice_id: user?.practice_id,
      sections: surveyAnswers,
    };
    const result = await saveAppointmentSurvey({ ...payload });
    if (result.error) {
      toast.error("Failed to save survey");
      console.error("Failed to save survey", result.error);
    }
    if (result?.data?.code == -1) {
      toast.error(result?.data?.msg);
      console.error("Failed to save survey", result.data?.msg);
    }
    if (result.data?.code === 0) {
      toast.success("Survey saved successfully");
      //   onCancelHandler();
      setSuccessfulModal(true);
    }
  };

  const onCancelHandler = () => {
    setShowSurvey(false);
    setSuccessfulModal(false);
  };

  const [successfulModal, setSuccessfulModal] = useState(false);
  return (
    <>
      {successfulModal && (
        <MainPageDialog
          title="Appointment"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Ok",
              type: "save",
              action: () => {
                setSuccessfulModal(false);
                onCancelHandler();
              },
            },
          ]}
          onCancelHandler={onCancelHandler}
          show={successfulModal}>
          <div className="p-4">
            <div className="text-center">
              <p className="text-lg">Survey saved successfully</p>
            </div>
          </div>
        </MainPageDialog>
      )}

      {!successfulModal && (
        <MainPageDialog
          title="Appointment Survey"
          modalSize="md"
          maxHeight={true}
          footerList={footerList}
          onCancelHandler={onCancelHandler}
          show={showSurvey}>
          <>
            {isLoading && <Loader />}
            {!isLoading && (
              <div>
                <div className="flex gap-2 mt-2">
                  <span className=" font-bold ">Appointment With</span> :
                  <span className="">{withName}</span>
                </div>
                <div className="flex gap-5 mt-2">
                  <span className="font-bold ">Date</span>:
                  <span>{moment(date).format("MM/DD/YYYY, h:mm:ss A")}</span>
                </div>
                <div className="flex gap-2 mt-2">
                  <span className="font-bold ">Duration</span>:
                  <span>{timeString}</span>
                </div>
                <div className="flex gap-2 mt-2">
                  <span className="font-bold">Location</span>:
                  <span>{location}</span>
                </div>
                <div class="flex-grow border-t border-gray-400 mt-8 mb-4 "></div>
                <h1 className="font-bold">Appointment Survey</h1>
                <div class="flex-grow border-t border-gray-400 mt-4 mb-4 "></div>
                {errorMessage && (
                  <div className="text-red-500 font-bold mb-2">
                    Please Select atleast one Answer
                  </div>
                )}
                {data?.sections?.map((section, seconIndex) => {
                  return (
                    <div>
                      <h1 className="font-bold">{section?.title}</h1>
                      {section?.questions?.map((question, index) => {
                        return (
                          <div className="p-4">
                            <h1>{question?.question}</h1>
                            <div className="flex gap-8 mt-4">
                              {question?.answers.map((option, index2) => {
                                return (
                                  <div
                                    className="cursor-pointer  items-center"
                                    onClick={() => {
                                      setErrorMessage(false);

                                      //make sections then index of section ,and then questions with index and answer key with that
                                      setSurveyAnswers({
                                        ...surveyAnswers,
                                        [seconIndex]: {
                                          questions: {
                                            ...surveyAnswers[seconIndex]
                                              ?.questions,
                                            [index]: {
                                              ...question,
                                              answers: option.value,
                                            },
                                          },
                                        },
                                      });

                                      // setSurveyAnswers({
                                      //   ...surveyAnswers,
                                      //   [option.key]: option.value,
                                      // });
                                    }}>
                                    <input
                                      type="radio"
                                      value={option.value}
                                      checked={
                                        surveyAnswers[seconIndex]?.questions?.[
                                          index
                                        ]?.answers === option.value
                                      }
                                      name={option.key}
                                    />
                                    <label className="ml-2 mb-2 cursor-pointer">
                                      {option.key}
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
            {data?.msg && !data?.sections && (
              <div className="font-bold fontobold p-4">{data?.msg}</div>
            )}
          </>
        </MainPageDialog>
      )}
    </>
  );
};

export default AppointmentSurvey;
